export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const APP_API_URL= "";
export const APP_IP_URL= "52.200.210.6"